import {
  JournalStatsActionsType,
  SET_JOURNAL_COMMON_STATISTICS,
  SET_JOURNAL_STATISTIC_VALUE,
  SET_JOURNAL_SYMPTOM_STATISTICS
} from './actions';
import {
  IJournalStatistic,
  IJournalStatisticValues,
  IJournalStatsActionHandler,
  IJournalStatsInitialState
} from './interfaces';

const JournalStatsInitialState: IJournalStatsInitialState = {
  commonStats: [],
  symptomStats: [],
  values: {}
};

const setCommonStats = ({
  state,
  payload
}: IJournalStatsActionHandler): IJournalStatsInitialState => {
  return {
    ...state,
    commonStats: payload as IJournalStatistic[]
  };
};

const setSymptomStats = ({
  state,
  payload
}: IJournalStatsActionHandler): IJournalStatsInitialState => {
  return {
    ...state,
    symptomStats: payload as IJournalStatistic[]
  };
};

const setStatValues = ({
  state,
  payload
}: IJournalStatsActionHandler): IJournalStatsInitialState => {
  if (!payload || !payload.length) {
    return state;
  }
  const vals = payload as IJournalStatisticValues[];
  const code = vals[0].xpeditionStatsCode;
  const values = state.values;

  values[code] = vals.map(v => {
    return {
      ...v
    };
  });

  return {
    ...state,
    values
  };
};

const journalStatsReducerHandlers = new Map([
  [SET_JOURNAL_COMMON_STATISTICS, setCommonStats],
  [SET_JOURNAL_SYMPTOM_STATISTICS, setSymptomStats],
  [SET_JOURNAL_STATISTIC_VALUE, setStatValues]
]);

const journalStatsReducer = (state = JournalStatsInitialState, action: JournalStatsActionsType): IJournalStatsInitialState => {
  const handler = journalStatsReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<IJournalStatsActionHandler>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default journalStatsReducer;
